import { render, staticRenderFns } from "./changeqamess.vue?vue&type=template&id=6309fb5c&scoped=true"
import script from "./changeqamess.vue?vue&type=script&lang=js"
export * from "./changeqamess.vue?vue&type=script&lang=js"
import style0 from "./changeqamess.vue?vue&type=style&index=0&id=6309fb5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309fb5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6309fb5c')) {
      api.createRecord('6309fb5c', component.options)
    } else {
      api.reload('6309fb5c', component.options)
    }
    module.hot.accept("./changeqamess.vue?vue&type=template&id=6309fb5c&scoped=true", function () {
      api.rerender('6309fb5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/changeqamess.vue"
export default component.exports